










































































import { Component, Vue, Watch } from 'vue-property-decorator';

import ScheduleGrid   from './components/ScheduleGrid.vue';
import ComplaintPairs from './components/ComplaintPairs.vue';
import Toggle         from './components/Toggle.vue';
import ProgressBar    from './components/ProgressBar.vue';

import Schedule from './model/Schedule';
import Options  from './model/Options';

import Annealer from './helpers/Annealer';

@Component({
  components: {
    ScheduleGrid,
    ComplaintPairs,
    Toggle,
    ProgressBar,
  },
})

export default class App extends Vue {
  public schedule = new Schedule({
    participants: [
      "Sally",
      "Fred",
      "Irene",
      "Harry",
      "Prudence",
      "Juan",
      "Vicky",
      "Yusuf",
      "Alvin",
    ],

    sessions: [
      "👻",
      "👾",
      "🦷",
      "👣",
      "🧚🏽‍♀️",
      "🐋",
      "🌈",
      "🌮",
      "🧿",
      "🧷",
      "💃🏻",
      "🧩",
    ],

    timeslots: ["1:00", "2:00", "3:00", "4:00"],
  });

  public options = new Options();

  public annealer = new Annealer(this.schedule, { maxIters: 1000 });

  constructor() {
    super();
    setTimeout(
      () => { // To prepopulate things for quick testing:
        // this.schedule.randomizeSlots();
        // this.schedule.randomizeVotes();
        // this.schedule.randomizeRanks();
        // this.options.showNaiveScores = true;
        // this.options.showFocusedShape = true;
        // this.options.showMiniShapes = true;
        // this.options.showPairs = true;
        // this.options.showRanking = true;
        // this.options.showShapeScores = true;
      }, 0.2);
  }

  @Watch('schedule.participants', { deep: true })
  public onVotesChanged(newValue: number, oldValue: number) {
    this.annealer.clear();
  }
}
